import type {SceneVoiceAttachment, SceneVoiceDraft} from '../../protocol/scene-voice';
export {editorUserMessage} from '../../protocol/user-message';
type Stage = (draft:SceneVoiceDraft)=>Promise<void>;
let stage:Stage|null=null;
const applied = new Set<(value:SceneVoiceAttachment)=>void>();
const reviewing=new Set<string>();
export function blockSceneVoiceStage(id:string){reviewing.add(id);return()=>{reviewing.delete(id);};}
/** Opens the host's explicit confirmation after saving. This never synthesizes audio. */
export function connectSceneVoiceStage(next:Stage){stage=next;return()=>{if(stage===next)stage=null;};}
export const hasSceneVoiceStage=()=>stage!==null;
export async function stageSceneVoice(draft:SceneVoiceDraft){
 if(reviewing.size)throw Error('먼저 열려 있는 장면 음성 교체 확인을 마쳐 주세요.');
 const current=stage;if(!current)throw Error('와카 작업에 연결한 뒤 장면 음성을 다시 만들어 주세요.');
 await current(draft);
 if(current!==stage)throw Error('작업 연결이 바뀌었습니다. 상단에서 저장 상태를 확인해 주세요.');
}
export function subscribeSceneVoiceApplied(callback:(value:SceneVoiceAttachment)=>void){applied.add(callback);return()=>{applied.delete(callback);};}
export function notifySceneVoiceApplied(value:SceneVoiceAttachment){for(const callback of applied)callback(value);}
type VoiceChoice={voice?:{code:string};tempo?:number;emotion?:{code:string};pitch?:number|null;style?:string};
export function shouldRefreshSceneVoiceChoice(current:VoiceChoice|null,baseline:VoiceChoice|null){
 const signature=(voice:VoiceChoice)=>JSON.stringify([voice.voice?.code,voice.tempo??1,voice.emotion?.code,voice.pitch??0,voice.style??'']);
 return !current||!baseline||signature(current)===signature(baseline);
}
export function matchesSubmittedSceneVoice(text:string,voice:VoiceChoice|null,value:SceneVoiceAttachment){
 return text===value.draftText&&voice?.voice?.code===value.settings.voiceId&&(voice.tempo??1)===value.settings.speed
  &&voice.emotion?.code===value.settings.emotion&&(voice.pitch??0)===(value.settings.pitch??0)&&(voice.style?.trim()??'')===(value.settings.style??'');
}

/** Value equality cannot detect editing a submitted draft back to its original value. */
export const hasNewerSceneVoiceDraft=(currentRevision:number,submittedRevision:number|null)=>submittedRevision!==null&&currentRevision>submittedRevision;
